import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PopoverController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { AppUser } from 'src/app/models/appUser.model';
import { AppuserService } from 'src/app/services/appuser/appuser.service';

@Component({
  selector: 'app-update-profile-popover',
  templateUrl: './update-profile-popover.component.html',
  styleUrls: ['./update-profile-popover.component.scss'],
})
export class UpdateProfilePopoverComponent  implements OnInit {

  appUser: AppUser;
  progress: number;

  constructor(
    public translate: TranslateService,
    private router: Router,
    private appUserService: AppuserService,
    private popoverController: PopoverController
  ) { 
    this.translate.setDefaultLang("en");
    this.translate.use(this.translate.getBrowserLang() || "en");
  }

  ngOnInit() {
    this.appUserService.getAppUser().then((appUser: AppUser) => {
      this.appUser = appUser;
    });
  }

  updateProfile() {
    this.router.navigate([`/home/edit-profile/${this.appUser.id}`]);
    this.popoverController.dismiss()
  }

  close() {
    this.popoverController.dismiss();
  }
}
